(function () {
  var API_BASE = 'https://api.rainierwatch.com/api/inventory';

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function computeStats(dropTotal, remaining) {
    var sold = dropTotal - remaining;
    sold = clamp(sold, 0, dropTotal);
    remaining = clamp(remaining, 0, dropTotal);
    var percentSold = dropTotal > 0 ? Math.round((sold / dropTotal) * 100) : 0;
    return { sold: sold, remaining: remaining, percentSold: percentSold };
  }

  function applyTokens(template, stats, dropTotal, dropDate) {
    if (!template) return '';
    return template
      .replace(/\{percent\}/g, String(stats.percentSold))
      .replace(/\{remaining\}/g, String(stats.remaining))
      .replace(/\{sold\}/g, String(stats.sold))
      .replace(/\{total\}/g, String(dropTotal))
      .replace(/\{date\}/g, dropDate || '');
  }

  function updateElement(root, stats, dropTotal) {
    var headingEl = root.querySelector('[data-limited-drop-heading]');
    var leftTextEl = root.querySelector('[data-limited-drop-left-text]');
    var rightTextEl = root.querySelector('[data-limited-drop-right-text]');
    var trackEl = root.querySelector('[data-limited-drop-track]');

    var headingTemplate = root.getAttribute('data-heading-template') || '';
    var leftTemplate = root.getAttribute('data-left-template') || '';
    var rightTemplate = root.getAttribute('data-right-template') || '';
    var dropDate = root.getAttribute('data-drop-date') || '';

    var headingText = applyTokens(headingTemplate, stats, dropTotal, dropDate);
    var leftText = applyTokens(leftTemplate, stats, dropTotal, dropDate);
    var rightText = applyTokens(rightTemplate, stats, dropTotal, dropDate);

    if (headingEl) headingEl.textContent = headingText;
    if (leftTextEl) leftTextEl.textContent = leftText;
    if (rightTextEl) rightTextEl.textContent = rightText;
    if (trackEl) {
      trackEl.style.setProperty('--drop-percent', String(stats.percentSold));
    }
    if (trackEl) {
      trackEl.setAttribute('aria-valuenow', String(stats.percentSold));
      trackEl.setAttribute('aria-label', headingText);
    }
  }

  function init(root) {
    var productId = root.getAttribute('data-product-id');
    var dropTotal = parseInt(root.getAttribute('data-drop-total'), 10);

    if (!productId || !dropTotal || dropTotal <= 0) return;

    fetch(API_BASE + '?product_id=' + encodeURIComponent(productId))
      .then(function (response) {
        if (!response.ok) throw new Error('inventory request failed');
        return response.json();
      })
      .then(function (data) {
        if (typeof data.total !== 'number') return;
        var stats = computeStats(dropTotal, data.total);
        updateElement(root, stats, dropTotal);
      })
      .catch(function () {
        /* Keep Liquid SSR values on failure */
      });
  }

  function boot() {
    document.querySelectorAll('[data-limited-drop-progress]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
